import fetchUgcData from '../services/ugc-data';

export default {
  props: {
    componentModels: { type: Object, default: () => {} },
    ugcModuleEnabled: { type: Boolean, default: false },
  },
  data() {
    return {
      ugcData: {},
      loadingFetch: false,
      errorFetch: false,
    };
  },
  computed: {
    ugcPlacementModule() {
      const { items, meta } = this.ugcData || {};
      const renderComponent = this.ugcData?.items?.length;
      return (
        (renderComponent && {
          items,
          meta,
          loading: this.loadingFetch,
          error: this.errorFetch,
        })
        || null
      );
    },
    ugcFilter() {
      const models = this.componentModels || {};
      const ugcGallery = models['ugc-gallery'] ?? models.ugcGallery;
      const { filter } = ugcGallery || {};
      return filter || '';
    },
    ugcRequireProductConfig() {
      const { ugcGallery } = this.componentModels || {};
      const { requireProduct } = ugcGallery || {};

      return (typeof requireProduct === 'boolean') ? requireProduct : true;
    },
    hasMoreItems() {
      const { after } = this.ugcPlacementModule?.meta || {};
      return {
        hasMore: !!after,
        after,
      };
    },
  },
  async mounted() {
    if (this.ugcModuleEnabled) {
      this.ugcData = await this.loadUgcData(this.ugcFilter, '', this.ugcRequireProductConfig);
    }
  },
  methods: {
    async loadUgcData(filter = '', after = '', requireProduct = true) {
      let data = {};
      this.loadingFetch = true;
      try {
        const res = await fetchUgcData(filter, after, requireProduct);
        if (res?.ok && res?.status === 200) {
          data = await res?.json();
        } else {
          this.errorFetch = true;
        }
      } catch (error) {
        this.errorFetch = true;
      }
      this.loadingFetch = false;
      return data;
    },
    async loadMoreUgcData() {
      if (this.hasMoreItems.hasMore) {
        const { items, meta } = await this.loadUgcData(
          this.ugcFilter,
          this.hasMoreItems.after,
          this.ugcRequireProductConfig,
        ) || {};
        this.ugcData?.items.push(...items.filter(
          (item) => !!item?.media?.large
        ));
        this.ugcData.meta = meta;
      }
    },
  },
};
